<ng-container *ngIf="initialized && dto">

    @if (activeNavigationItem.action == 'standard') {
<!--        <cm-contract-standard-navigation-->
<!--                [objectIdentifier]="objectIdentifier"-->
<!--                [importObjectContext]="customerImportObjectContext"-->
<!--                [dto]="dto"-->
<!--        ></cm-contract-standard-navigation>-->
        <cm-shared-component
                [objectIdentifier]="objectIdentifier"
                [contract]="dto"
                [customer]="dto['joinCurrentMainCustomer']">
        </cm-shared-component>
    }

    @if (activeNavigationItem.action == 'documentUpload') {
        <cm-contract-document-upload
                [objectIdentifier]="objectIdentifier">
        </cm-contract-document-upload>
    }

    @if (activeNavigationItem.action == 'objects') {
        <cm-contract-objects-navigation
                [contractDto]="dto"
                [customerDto]="dto['joinCurrentMainCustomer']">
        </cm-contract-objects-navigation>
    }

    @if (activeNavigationItem.action == 'externalData') {
        <cm-contract-external-data-navigation [contractDto]="dto">
        </cm-contract-external-data-navigation>
    }

    @if (activeNavigationItem.action == 'coverages') {
        <cm-contract-coverages-navigation [contractDto]="dto">
        </cm-contract-coverages-navigation>
    }

    @if (activeNavigationItem.action == 'notifications') {

        <mvs-ns-notification-types-for-object
                [objectIdentifier]="objectIdentifier"
                [mode]="1"
                class="mvs-widget block"
        ></mvs-ns-notification-types-for-object>
    }

    @if (activeNavigationItem.action == 'genericTickets') {

        <mvs-ticket
                [visible]="activeNavigationItem.action == 'genericTickets'"
                [objectIdentifier]="contractIdentifier"
                (onTicketsCount)="handleTicketsCount($event)">
        </mvs-ticket>
    }

    @if (activeNavigationItem.action == 'genericWorkflows') {

        <mvs-workflow
                [visible]="activeNavigationItem.action == 'genericWorkflows'"
                [objectRequestList]="workflowObjectRequestList"
                (onWorkflowCount)="handleWorkflowsCount($event)">
        </mvs-workflow>
    }
<!--    @if (activeNavigationItem.action == 'calculator') {-->
<!--        <bm-contract-payment-calculator-->
<!--                [contractId]="objectIdentifier.objectId"-->
<!--                view="side"-->
<!--                [startDate]="dto['startDate']">-->
<!--        </bm-contract-payment-calculator>-->
<!--    }-->

</ng-container>
